import { useCallback, useState } from "react";

import { ExerciseId } from "../types";
import { getExcludedIds, getFavouritesIds, setExcludedId, setFavouriteId } from "./localStorage";

export function useFavouritesAndExcluded() {
    const [favourites, setFavourites] = useState(getFavouritesIds());
    const handleSetFavourites = useCallback((id: ExerciseId, value: boolean) => {
        setFavouriteId(id, !!value);
        setFavourites(getFavouritesIds());
    }, []);

    const [excluded, setExcluded] = useState(getExcludedIds());
    const handleSetExcluded = useCallback((id: ExerciseId, value: boolean) => {
        setExcludedId(id, !!value);
        setExcluded(getExcludedIds());
    }, []);

    return {
        favourites,
        excluded,
        setFavourite: handleSetFavourites,
        setExcluded: handleSetExcluded,
    };
}
